var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.329712,
    width: 34,
    height: 34,
    rx: 17,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.860962,
    y: 0.53125,
    width: 32.9375,
    height: 32.9375,
    rx: 16.4688,
    stroke: "#005DA8",
    strokeOpacity: 0.2,
    strokeWidth: 1.0625
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.142 11.0075C17.0274 10.774 14.8963 10.7567 12.7785 10.9556L11.3644 11.0885C10.1958 11.1983 9.25162 12.1363 9.08191 13.356C8.74565 15.7726 8.74565 18.2278 9.08191 20.6443C9.25162 21.8641 10.1958 22.8021 11.3644 22.9118L12.7785 23.0447C14.8963 23.2437 17.0274 23.2263 19.142 22.9929L19.6853 22.9329C20.7975 22.8101 21.6974 21.9402 21.914 20.7984L24.638 22.3188C24.8366 22.4298 25.0748 22.4286 25.2725 22.3158C25.4702 22.203 25.6008 21.9937 25.6204 21.7583L25.6427 21.4917C25.892 18.5031 25.892 15.4973 25.6427 12.5087L25.6204 12.2421C25.6008 12.0067 25.4702 11.7973 25.2725 11.6845C25.0748 11.5717 24.8366 11.5706 24.638 11.6815L21.914 13.202C21.6974 12.0601 20.7975 11.1902 19.6853 11.0675L19.142 11.0075ZM12.8979 12.359C14.9293 12.1682 16.9736 12.1848 19.0019 12.4087L19.5451 12.4687C20.0919 12.5291 20.5301 12.9712 20.6097 13.5428C20.9287 15.8355 20.9287 18.1648 20.6097 20.4575C20.5301 21.0291 20.0919 21.4713 19.5451 21.5316L19.0019 21.5916C16.9736 21.8155 14.9293 21.8322 12.8979 21.6413L11.4838 21.5085C10.9334 21.4567 10.4887 21.015 10.4088 20.4405C10.0913 18.1591 10.0913 15.8412 10.4088 13.5598C10.4887 12.9853 10.9334 12.5435 11.4838 12.4918L12.8979 12.359ZM22.0902 14.6992C22.2232 16.2299 22.2232 17.7704 22.0902 19.3012L24.3672 20.5723C24.5292 18.1939 24.5292 15.8064 24.3672 13.4281L22.0902 14.6992Z",
    fill: "#005DA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.f206058bc53645cf20bacec00922b0ea.svg";
export { ForwardRef as ReactComponent };